import { Base } from "./base";

export interface LiftvanConfig extends Base {
  autoNumber: boolean;
  capacity: number;
  howMany: number;
  id?: number;
  jobId?: number;
  prefix?: string;
}

export const defaultLiftvanConfig: LiftvanConfig = {
  autoNumber: false,
  capacity: 0,
  howMany: 0,
};
